import React from 'react';

import { useLazyLoad } from '../hooks';

function GoogleMap() {
  const {
    inView,
    ref,
    srcRef,
    isLoaded,
    handleIsLoaded,
    Spinner,
  } = useLazyLoad();
  return (
    <article
      ref={ref}
      className="relative h-0 aspect-ratio-16/9 lg:aspect-ratio-none lg:h-96"
    >
      {inView && (
        <iframe
          ref={srcRef}
          onLoad={handleIsLoaded}
          data-src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3404.4393075278817!2d152.9049042518268!3d-31.42957070394586!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b9dff27b498d799%3A0x8cc0263883170841!2s1%2F68%20Clarence%20St%2C%20Port%20Macquarie%20NSW%202444!5e0!3m2!1sen!2sau!4v1600671322683!5m2!1sen!2sau"
          frameBorder={0}
          allowFullScreen
          aria-hidden={false}
          tabIndex={0}
          title="Location"
          className="absolute inset-0 w-full h-full"
        />
      )}
      {!isLoaded && <Spinner />}
    </article>
  );
}

export { GoogleMap };
